<template>
  <div class="container">
    <div class="row">
      <div class="form-group col-md-4">
        <label class="control-label">
          ¿ Realiza actividades empresariales ?
        </label>
        <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <legend>Sueldos y salarios por otros empleos</legend>
        </div>
        <div class="row">

          <div class="form-group col-md-8">
            <label class="control-label">Nombre, denominación o razón social</label>
            <input class="form-control" type="text" v-model="item_actividades.nombre_denominacion_razon_social" placeholder="Nombre, denominación o razón social de quien se adquirió el inmueble:">
          </div>
          <div class="form-group col-md-4">
            <label class="control-label">RFC (si aplica)</label>
            <input class="form-control" type="text" v-model="item_actividades.rfc" placeholder="RFC">
          </div>
          <div class="form-group col-md-4">
            <label class="control-label">CURP (si aplica)</label>
            <input class="form-control" type="text" v-model="item_actividades.curp" placeholder="CURP">
          </div>
          <div class="form-group col-md-4">
            <label class="control-label">Sector / Industria (si aplica)</label>
            <el-select  clearable class="select-default" placeholder="Seleccione una opción" v-model="item_actividades.sector_industria_id">
              <el-option v-for="option in sectores" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
          </div>
          <div class="form-group col-md-4">
            <label class="control-label">Tipo de actividad o servicio que produjo el ingreso</label>
            <el-select  clearable class="select-default" placeholder="Seleccione una opción" v-model="item_actividades.tipo_actividad_servicio_id">
              <el-option v-for="option in actividades" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
          </div>

          <div class="form-group col-md-4">
            <label class="control-label">Descripción de la actividad que produce el ingreso</label>
            <input class="form-control" type="text" v-model="item_actividades.descripcion_actividad_servicio" placeholder="Descripción de la actividad">
          </div>

          <div class="form-group col-md-4 customCurrency">
            <label class="control-label">Ingreso bruto anual recibido por la actividad</label>
            <b-input-group size="sm" :prepend="getSigno">
              <b-form-input type="number" class="text-right" v-model="item_actividades.ingreso_bruto_anual" placeholder="0" @keyup.native="isNumber" />
              <b-dropdown right split :text="getCodigoMoneda" v-model="item_actividades.moneda_id">
                <b-dropdown-item v-for="option in monedas" :key="option.codigo" :value="option.codigo" @click="item_actividades.moneda_id = option.id">{{option.moneda}}</b-dropdown-item>
              </b-dropdown>
            </b-input-group>
          </div>

          <div class="form-group col-md-4">
            <label class="control-label">Duración o frecuencia </label>
            <input class="form-control" type="text" v-model="item_actividades.duracion_frecuencia" placeholder="Frecuencia">
          </div>

          <div class="form-group col-md-4">
            <label class="control-label">Unidad temporal</label>
            <el-select  clearable class="select-default" placeholder="Seleccione una opción" v-model="item_actividades.unidad_temporal_id">
              <el-option v-for="option in plazos" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
          </div>

          <div class="form-group col-md-4" v-if="item_actividades.unidad_temporal_id == 4">
            <label class="control-label">Fecha de transacción</label>
            <el-date-picker v-model="item_actividades.fecha_transaccion" type="date" placeholder="Seleccione fecha" value-format="dd-MM-yyyy" format="dd-MM-yyyy"></el-date-picker>
          </div>

          <div class="form-group col">
            <label class="control-label">Observaciones / Comentarios</label>
            <input class="form-control" type="text" v-model="item_actividades.observaciones" placeholder="Observaciones / Comentarios">
          </div>
        </div>

        <domicilio titulo="" v-model="n_domicilio"></domicilio>

        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="edit_item == null">
              <i class="fa fa-plus"></i> Agregar
            </span>

            <span v-else>
              <i class="fa fa-save"></i> Guardar
            </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar
            </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar
            </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <b-table id="tbl_actividades" responsive hover :items="list_actividades" :fields="fields_list" show-empty>
              <!-- :fields="fields_list" -->
              <template slot="acciones" slot-scope="row" class="actions">
                <b-button size="sm" @click.prevent="editItem(row)" class="edit mr-2" :disabled="edit_item != null">
                  Editar <i class="fas fa-pencil-alt ml-2"></i>
                </b-button>
                <b-button size="sm" @click.prevent="removeItem(row.index)" class="delete mr-2" :disabled="edit_item != null">
                  Eliminar <i class="fas fa-trash-alt ml-2"></i>
                </b-button>
              </template>
              <template slot="empty">
                <h5>No existen registros</h5>
              </template>

              <template slot="entidad_federativa_id" slot-scope="row">
                {{getEntidad(row.item.entidad_federativa_id)}}</template>
              <template slot="localidad_id" slot-scope="row">
                {{getLocalidad(row.item.localidad_id)}}
              </template>
              <template slot="municipio_id" slot-scope="row">{{getMunicipio(row.item.municipio_id)}}</template>
              <template slot="pais_id" slot-scope="row">{{getPais(row.item.pais_id)}}</template>

              <template slot="sector_industria_id" slot-scope="row">{{getSector(row.item.sector_industria_id)}}</template>
              <template slot="tipo_actividad_servicio_id" slot-scope="row">{{getActividad(row.item.tipo_actividad_servicio_id)}}</template>

              <template slot="ingreso_bruto_anual" slot-scope="row" class="text-right">{{(getSignoDos(row.item.moneda_id))}}
                {{row.item.ingreso_bruto_anual | currency}}</template>
              <template slot="moneda_id" slot-scope="row" class="text-center">
                {{getMoneda(row.item.moneda_id)}}</template>

              <template slot="unidad_temporal_id" slot-scope="row">{{getUnidades(row.item.unidad_temporal_id)}}</template>

            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from "element-ui";
  import Domicilio from "../Domicilio.vue";
  import {
    mapFields
  } from "vee-validate";
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber,
      Domicilio
    },
    props: ["data"],
    data() {
      return {
        ip_id: 1,
        add_item: false,
        edit_item: null,
        bandera: '0',
        modelValidations: {
          nombre: {
            min: 5
          },
          email: {
            required: true,
            email: true
          }
        },
        entes: null,
        monedas: [],
        plazos: [],
        actividades: [],
        sectores: null,
        n_domicilio: null,
        monedas: [],
        entidadFed: null,
        municipios: null,
        localidades: null,
        localidad: null,
        paises: null,
        isnum: null,
        /* Lista de Bienes */
        item_actividades: {},
        list_actividades: [],
        fields_list: [{
            key: "acciones",
            label: "Acciones",
            tdClass: "text-center"
          },
          {
            key: "nombre_denominacion_razon_social",
            label: "Denominación o razón social",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "rfc",
            label: "RFC",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "curp",
            label: "CURP",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "sector_industria_id",
            label: "Sector",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "tipo_actividad_servicio_id",
            label: "Tipo de actividad ",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "descripcion_actividad_servicio",
            label: "Descripción de la actividad",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "ingreso_bruto_anual",
            label: "Ingreso bruto anual ",
            tdClass: "text-right",
            formatter: 'emptyFields'
          },
          {
            key: "moneda_id",
            label: "Moneda",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "duracion_frecuencia",
            label: "Duración / Frecuencia",
            tdClass: "text-center",
            formatter: 'emptyFields'
          },
          {
            key: "unidad_temporal_id",
            label: "Unidad temporal",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "fecha_transaccion",
            label: "Fecha de transacción",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "observaciones",
            label: "Observaciones",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "pais_id",
            label: "País",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "entidad_federativa_id",
            label: "Entidad federativa",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "municipio_id",
            label: "Municipio",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "localidad_id",
            label: "Localidad",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "colonia",
            label: "Colonia",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "vialidad_tipo_vial",
            label: "Tipo vialidad",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "vialidad_nom_vial",
            label: "Nombre vialidad",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "cp",
            label: "CP",
            tdClass: "text-right",
            formatter: 'emptyFields'
          },
          {
            key: "numExt",
            label: "Número exterior",
            tdClass: "text-right",
            formatter: 'emptyFields'
          },
          {
            key: "numInt",
            label: "Número interior",
            tdClass: "text-right",
            formatter: 'emptyFields'
          },
        ]
      };
    },
    computed: {
      getSigno() {
        var signo = "$";
        var val = this.item_actividades.moneda_id;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            signo = item.signo;
          }
        });
        return signo;
      },
      getCodigoMoneda() {
        var codigo = "MXN";
        var val = this.item_actividades.moneda_id;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            codigo = item.codigo;
          }
        });
        return codigo;
      },
    },
    watch: {
      list_actividades: {
        handler: function () {
          if (this.list_actividades) {
            this.setLocalidades();
            if (this.list_actividades.length == 0) {
              this.bandera = '0';
            } else {
              this.bandera = '1';
            }
          }
        },
        deep: true
      },
      n_domicilio: {
        handler: function () {
          if (this.n_domicilio) {
            this.item_actividades.pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
            this.item_actividades.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
            this.item_actividades.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
            this.item_actividades.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
            this.item_actividades.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
            this.item_actividades.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
            this.item_actividades.vialidad_tipo_vial = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
            this.item_actividades.vialidad_nom_vial = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
            this.item_actividades.numExt = this.n_domicilio.ext ? this.n_domicilio.ext : "";
            this.item_actividades.numInt = this.n_domicilio.int ? this.n_domicilio.int : "";
          }
        },
        deep: true
      },
    },
    methods: {
      getSignoDos(val = "97") {
        var signo = "$";
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            signo = item.signo;
          }
        });
        return signo;
      },
      emptyFields(value) {
        if (value) {
          if (typeof value === 'string' || value instanceof String) {
            return value.toUpperCase();
          } else {
            return value;
          }
        } else {
          return '-';
        }
      },
      getEnte(index) {
        var resp = " ";
        if (this.entes) {
          this.entes.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getMoneda(index) {
        var resp = "";
        if (this.monedas) {
          this.monedas.forEach(function (item) {
            if (item.id == index) {
              resp = item.moneda;
            }
          });
        }
        return resp;
      },
      getSector(index) {
        var resp = " ";
        if (this.sectores) {
          this.sectores.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getActividad(index) {
        var resp = " ";
        if (this.sectores) {
          this.actividades.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getUnidades(index) {
        var resp = " ";
        if (this.plazos) {
          this.plazos.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getEntidad(index) {
        var resp = " ";
        if (this.entidadFed) {
          this.entidadFed.forEach(function (item) {
            if (item.id == index) {
              resp = item.nom_ent;
              return resp;
            }
          });
        }
        return resp;
      },
      getLocalidad(index) {
        var resp = "";
        if (this.localidades) {
          this.localidades.forEach(function (item) {
            if (item.id == index) {
              resp = item.nom_loc;
              return resp;
            }
          });
        }
        return resp;
      },
      getMunicipio(index) {
        var resp = "";
        if (this.municipios) {
          this.municipios.forEach(function (item) {
            if (item.id == index) {
              resp = item.nom_mun;
              return resp;
            }
          });
        }
        return resp;
      },
      getPais(index) {
        var resp = "México";
        if (this.paises) {
          this.paises.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      initItem() {
        this.n_domicilio = {
          pais_id: 150,
          entidadF: '',
          municipio: '',
          localidad: '',
          cp: '',
          colonia: '',
          vialidad: '',
          vialidad_nombre: '',
          ext: '',
          int: ''
        };
        this.item_actividades = {
          acciones: "",
          rfc_quien_adquirio: "",
          ingreso_bruto_anual: "",
          moneda_id: 97,
          unidad_temporal_id: '',
          duracion_frecuencia: '',
          fecha_transaccion: '',
          pais_id: "",
          entidad_federativa_id: "",
          municipio_id: "",
          localidad_id: "",
          colonia: "",
          cp: "",
          numExt: "",
          numInt: "",
          vialidad_nom_vial: "",
          vialidad_tipo_vial: "",
          observaciones: ""
        };
      },
      showItem() {
        this.add_item = !this.add_item;
      },
      cancelEdit() {
        if (this.edit_item) {
          this.edit_item.item._rowVariant = "";
        }
        this.initItem();
        this.showItem();
        this.edit_item = null;
      },
      addItem() {
        if (this.item_actividades) {
          this.item_actividades.ip_id = this.ip_id;
          this.loadButton(this.$refs.btnSave);
          this.$http.post("actividades_empresariales", this.item_actividades).then(
            response => {
              this.StepOk("Guardado");
              if (this.edit_item === undefined || this.edit_item === null) {
                this.list_actividades.push({
                  ...response.data.actividad
                });
              } else {
                this.list_actividades.splice(
                  this.edit_item.index,
                  1,
                  this.item_actividades
                );
                this.edit_item.item._rowVariant = "";
              }
              this.showItem();
              this.initItem();
              this.edit_item = null;
            },
            error => {
              this.StepError(error);
              //this.change =  true;
            }
          );
        } else {
          this.StepW("Hay campos sin completar");
        }
        //console.log(this.item_actividades);
      },
      editItem(indice) {
        this.showItem();
        this.edit_item = indice;
        this.item_actividades = {
          ...this.list_actividades[this.edit_item.index]
        };
        this.editDomicilio();
        this.edit_item.item._rowVariant = "danger";
        $(".main-panel").animate({
            scrollTop: 100
          },
          500,
          "swing"
        );
      },
      removeItem(indice) {
        if (this.list_actividades[indice].id !== null) {
          let item = this.list_actividades[indice];
          //this.list_actividades.splice(indice, 1);
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("actividades_empresariales/" + item.id).then(
              response => {
                /* eventBus.$emit("TramiteDelete", item); */
                this.list_actividades.splice(indice, 1);
              },
              error => {
                this.Err(error);
              }
            );
          });
        }
      },
      validate() {
        return this.$validator.validateAll();
      },
      editDomicilio() {
        this.n_domicilio.pais_id = this.item_actividades.pais_id ? this.item_actividades.pais_id : 150;
        this.n_domicilio.entidadF = this.item_actividades.entidad_federativa_id ? this.item_actividades.entidad_federativa_id : '';
        this.n_domicilio.municipio = this.item_actividades.municipio_id ? this.item_actividades.municipio_id : '';
        this.n_domicilio.localidad = this.item_actividades.localidad_id ? this.item_actividades.localidad_id : '';
        this.n_domicilio.cp = this.item_actividades.cp ? this.item_actividades.cp : '';
        this.n_domicilio.colonia = this.item_actividades.colonia ? this.item_actividades.colonia : '';
        this.n_domicilio.vialidad = this.item_actividades.vialidad_tipo_vial ? this.item_actividades.vialidad_tipo_vial : '';
        this.n_domicilio.vialidad_nombre = this.item_actividades.vialidad_nom_vial ? this.item_actividades.vialidad_nom_vial : '';
        this.n_domicilio.ext = this.item_actividades.numExt ? this.item_actividades.numExt : '';
        this.n_domicilio.int = this.item_actividades.numInt ? this.item_actividades.numInt : '';
      },
      setLocalidades() {
        this.localidades = [];
        this.list_actividades.forEach((item) => {
          if (item.localidad_id) {
            this.$http.get('localidades/localidad/' + item.localidad_id).then(
              response => {
                this.localidades.push(response.data.localidad);
              },
              error => {
                this.Err(error);
              }
            );
          }
        });
      },
      isNumber(n) {
        //console.log(n);
        n.target.value = n.target.value.replace(/[^\d.-]/g, '');
      }
    },
    created() {
      this.initItem();
      //this.getLocalidades(97250);
      this.$http.get("actividades_empresariales/" + this.ip_id).then(
        response => {
          this.list_actividades = response.data.actividades;
          this.setLocalidades();
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("cat_ente_publico").then(
        response => {
          this.entes = response.data.entes_publicos;
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("cat_unidad_medida_plazo").then(
        response => {
          this.plazos = response.data.unidades;
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("cat_sector_industria").then(
        response => {
          this.sectores = response.data.sectores;
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("cat_tipo_actividad").then(
        response => {
          this.actividades = response.data.actividad;
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("entidadFed").then(
        response => {
          this.entidadFed = response.data.entidadfed;
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("paises").then(
        response => {
          this.paises = response.data.pais;
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("municipios").then(
        response => {
          this.municipios = response.data.municipios;
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("monedas").then(
        response => {
          this.monedas = response.data.monedas;
          var temp = "97";
          this.monedas.forEach(function (item) {
            if (item.codigo == "MXN") {
              temp = item.id;
            }
          });
          this.item_actividades.moneda_id = temp;
        },
        error => {
          this.Err(error);
        }
      );
    }
  };

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Ingresos/ActividadEmpresarial.vue